export const initShowPassword = function() {
  const btnShow = document.querySelectorAll('[data-password-show]');

  if (btnShow.length > 0) {
    btnShow.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        const parent = item.closest('.form__input-wrapper');
        const input = parent.querySelector('input');
        if (input.getAttribute('type') === 'password') {
          input.setAttribute('type', 'text');
          item.classList.add('is-active');
        } else {
          input.setAttribute('type', 'password');
          item.classList.remove('is-active');
        }
      });
    });
  }
};
